// src/pages/AchievementsMorePage.jsx
// ✅ "Click here..." zoom in/out animation

import * as React from "react";
import {
  Box,
  Container,
  Typography,
  Stack,
  Button,
  useMediaQuery,
} from "@mui/material";
import { alpha, useTheme, keyframes } from "@mui/material/styles";
import { Link } from "react-router-dom";

import bigImg from "../assets/Achievement.jpg";

// ✅ Zoom in/out animation
const zoomPulse = keyframes`
  0%   { transform: scale(1);   opacity: 0.95; }
  50%  { transform: scale(1.06); opacity: 1; }
  100% { transform: scale(1);   opacity: 0.95; }
`;

export default function AchievementsMorePage() {
  const theme = useTheme();
  const isDesktop1080 = useMediaQuery("(min-width:1080px)");

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f9fafb",
        py: { xs: 4, md: 6 },
      }}
     
    >
      {/* ================= Content Section ================= */}
      <Container maxWidth="md">
        <Stack spacing={2} alignItems="center">
          <Typography variant="h4" fontWeight={800} textAlign="center">
            Achievements – Detailed Overview
          </Typography>

          {/* ✅ Animated "Click here..." */}
          <Typography
            variant="h6"
            fontWeight={300}
            textAlign="center"
            sx={{
              mt: "20px",
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              animation: `${zoomPulse} 1.35s ease-in-out infinite`,
              transformOrigin: "center",
              willChange: "transform",
              userSelect: "none",
            }}
          >
            Click here to image see highlighted achievements{" "}
            <span aria-hidden="true">👇</span>
          </Typography>
        </Stack>
      </Container>

      {/* ================= Image Section ================= */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Box
          sx={{
            width: { xs: "92%", sm: "88%", md: "85%" },
            borderRadius: 4,
            border: "1px solid rgba(0,0,0,0.12)",
            boxShadow: "0 14px 40px rgba(0,0,0,0.10)",
            overflow: "hidden",
            backgroundColor: "#fff",
            position: "relative",
            mt: "10px",
          }}
        >
          <a
            href="https://seedfund.startupindia.gov.in/startup_portfolio"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", display: "block" }}
          >
            <Box
              component="img"
              src={bigImg}
              alt="Achievements"
              sx={{
                width: "100%",
                height: "auto",
                display: "block",
                objectFit: "contain",
                cursor: "pointer",
              }}
            />
          </a>

          {isDesktop1080 && (
            <Box
              sx={{
                position: "absolute",
                left: "50%",
                bottom: 18,
                transform: "translateX(-50%)",
              }}
            >
              <Link to="/achievements" style={{ textDecoration: "none" }}>
                <Button
                  onClick={scrollToTop}
                  variant="contained"
                  sx={{
                    borderRadius: 999,
                    px: 3,
                    py: 1,
                    fontWeight: 800,
                    textTransform: "none",
                    backgroundColor: alpha(theme.palette.primary.main, 0.95),
                    boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
                    "&:hover": { backgroundColor: theme.palette.primary.main },
                  }}
                >
                  See More Achievements
                </Button>
              </Link>
            </Box>
          )}
        </Box>
      </Box>

      {!isDesktop1080 && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2, mb: 5 }}>
          <Link to="/achievements" style={{ textDecoration: "none" }}>
            <Button
              onClick={scrollToTop}
              variant="contained"
              sx={{
                borderRadius: 999,
                px: { xs: 2.2, sm: 3 },
                py: 1,
                fontWeight: 800,
                textTransform: "none",
                backgroundColor: alpha(theme.palette.primary.main, 0.95),
                boxShadow: "0 10px 25px rgba(0,0,0,0.18)",
                "&:hover": { backgroundColor: theme.palette.primary.main },
              }}
            >
              See More Achievements
            </Button>
          </Link>
        </Box>
      )}
    </Box>
  );
}
